export default "__VITE_ASSET__6AwRhqiT__"